var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRedIcon24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24.0 24.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M14.1527282,5.90272818 L10.9997282,9.05572818 L7.84727182,5.90272818 L5.90272818,7.84727182 L9.05572818,10.9997282 L5.90272818,14.1527282 L7.84727182,16.0972718 L10.9997282,12.9437282 L14.1527282,16.0972718 L16.0972718,14.1527282 L12.9437282,10.9997282 L16.0972718,7.84727182 L14.1527282,5.90272818 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    stroke: "none",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,6.5 L10,15.5",
    stroke: "#FF0000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,11 L15.5,11",
    stroke: "#FF0000",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRedIcon24Px);
export default __webpack_public_path__ + "static/media/close-red-icon-24px.2ad783b99ed06b79d0f7dbc77f471a59.svg";
export { ForwardRef as ReactComponent };